import ApiService from './ApiService';

class SettingTopPageApi extends ApiService {

    getThemeTopPage(typeTheme) {
        return this.get('top-page/theme', { key: typeTheme });
    }
}

export default SettingTopPageApi;
